export default "__VITE_ASSET__DJaTBigt__"